import { put } from "redux-saga/effects";

import { appInstance } from "axios-config";
import * as actions from "./actions";
import { NOTIFICATION_STATUS } from "App/componentsConfig";
import { showNotificationWithTimeout } from "store/actions";
import { NOTIFICATIONS } from "consts";

export function* fetchBackupPlansStart() {
  try {
    const response = yield appInstance.get("/backupPlan/all");
    if (response.status === 200)
      yield put(actions.fetchBackupPlansSuccess(response.data));
  } catch (error) {
    console.log(error);
  }
}

export function* enableBackupPlanStart(action) {
  try {
    const response = yield appInstance.post(
      "/backupPlan/enablePlans",
      action.data
    );

    if (response.status === 200) {
      yield put(actions.enableBackupPlanSuccess(action.data));
      yield put(
        showNotificationWithTimeout("backupPlan", {
          status: NOTIFICATION_STATUS.success.name,
          msg: NOTIFICATIONS.backupPlan.enable.enableSuccess
        })
      );
    }
  } catch (error) {
    console.log(error);
  }
}
export function* fetchBackupPlansSettingStart(action) {
  try {
    const response = yield appInstance.get(
      "/backupPlan/settings?backupPlanID=" + action.backupPlanID
    );
    yield put(
      actions.fetchBackupPlansSettingSuccess({
        ...response.data,
        ...{ planId: action.backupPlanID }
      })
    );
  } catch (error) {
    console.log(error);
  }
}

export function* disableBackupPlanStart(action) {
  try {
    const response = yield appInstance.post(
      "/backupPlan/disablePlans",
      action.data
    );

    if (response.status === 200) {
      yield put(actions.disableBackupPlanSuccess(action.data));
      yield put(
        showNotificationWithTimeout("backupPlan", {
          status: NOTIFICATION_STATUS.success.name,
          msg: NOTIFICATIONS.backupPlan.disable.disableSuccess
        })
      );
    }
  } catch (error) {
    console.log(error);
  }
}

export function* deleteBackupPlanStart(action) {
  try {
    const response = yield appInstance.delete("/backupPlan/settings", {
      data: action.data
    });
    if (response.status === 200) {
      yield put(actions.deleteBackupPlanSuccess(action.data));
      yield put(
        showNotificationWithTimeout("backupPlan", {
          status: NOTIFICATION_STATUS.success.name,
          msg: NOTIFICATIONS.backupPlan.delete.deleteSuccess
        })
      );
    }
  } catch (error) {
    console.log(error);
  }
}

export function* saveBackupPlansSettingStart(action) {
  try {
    const response = yield appInstance.put("/backupPlan/settings", action.data);

    if (response.status === 200) {
      yield put(actions.saveBackupPlansSettingSuccess(action.data));
      yield put(
        showNotificationWithTimeout("backupPlan", {
          msg: NOTIFICATIONS.backupPlan.settings.success,
          status: NOTIFICATION_STATUS.success.name
        })
      );
      yield put(actions.cleanBackupPlanCache("cachePlanSettings"));
    } else {
      yield put(actions.saveBackupPlansSettingFailure());
      yield put(actions.cleanBackupPlanCache("cachePlanSettings"));
      yield put(
        showNotificationWithTimeout("backupPlan", {
          status: NOTIFICATION_STATUS.failure.name,
          msg: NOTIFICATIONS.backupPlan.settings.failure
        })
      );
    }
  } catch (error) {
    yield put(actions.saveBackupPlansSettingFailure());
    yield put(actions.cleanBackupPlanCache("cachePlanSettings"));
    yield put(
      showNotificationWithTimeout("backupPlan", {
        status: NOTIFICATION_STATUS.failure.name,
        msg: NOTIFICATIONS.backupPlan.settings.failure
      })
    );
    console.log(error);
  }
}

export function* createNewBackupPlanStart(action) {
  try {
    const response = yield appInstance.post(
      "/backupPlan/settings",
      action.data
    );

    if (response.status === 200) {
      yield put(actions.createNewBackupPlanSuccess(action.data));
      yield put(actions.cleanBackupPlanCache("cachePlanSettings"));
      yield put(actions.fetchBackupPlansStart());
      yield put(
        showNotificationWithTimeout("backupPlan", {
          msg: NOTIFICATIONS.backupPlan.createNew.success,
          status: NOTIFICATION_STATUS.success.name
        })
      );
    } else {
      yield put(actions.saveBackupPlansSettingFailure());
      yield put(actions.cleanBackupPlanCache("cachePlanSettings"));
      yield put(
        showNotificationWithTimeout("backupPlan", {
          status: NOTIFICATION_STATUS.failure.name,
          msg: NOTIFICATIONS.backupPlan.createNew.failure
        })
      );
    }
  } catch (error) {
    yield put(actions.saveBackupPlansSettingFailure());
    yield put(actions.cleanBackupPlanCache("cachePlanSettings"));
    yield put(
      showNotificationWithTimeout("backupPlan", {
        status: NOTIFICATION_STATUS.failure.name,
        msg: NOTIFICATIONS.backupPlan.createNew.failure
      })
    );
    console.log(error);
  }
}

export function* fetchDefaultPlanToCreatePlanStart() {
  try {
    const response = yield appInstance.get("/backupPlan/defaultSettings");
    if (response.status === 200)
      yield put(actions.fetchDefaultPlanToCreatePlanSuccess(response.data));
  } catch (error) {
    console.log(error);
  }
}
